import axios from 'axios'
export const API_URL = process.env.REACT_APP_BASE_API_URL
const COMPLIANCE_MEETING = `${API_URL}/compliance/meetings`
const MEETING_SUB_CATEGORY = `${API_URL}/ref-data?group=complianceSubCategory`

export const complianceSubCategory = () => {
  return axios.get(`${MEETING_SUB_CATEGORY}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createMeeting = (data: any, companyId: any) => {
  return axios.post(`${COMPLIANCE_MEETING}`, data, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createAgenda = (data: any, id: string) => {
  return axios.post(`${COMPLIANCE_MEETING}/${id}/agendas`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAgenda = (
  id: string,
  all?: boolean,
  page?: number,
  pageSize?: number,
  type?: string,
  sortBy?: string
) => {
  return axios.get(
    `${COMPLIANCE_MEETING}/${id}/agendas?${page ? `&page=${page}` : ''}${
      pageSize ? `&pageSize=${pageSize}` : ''
    }${type ? `&type=${type}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}${all ? `&all=${all}` : ''}`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteAgenda = (id: string) => {
  return axios.delete(`${COMPLIANCE_MEETING}/agendas/${id}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateAgenda = (data: any, meetingId: string, id: string) => {
  return axios.post(`${COMPLIANCE_MEETING}/${meetingId}/agendas/${id}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const createParticipants = (data: any, meetingId: string, companyId: any) => {
  return axios.post(`${COMPLIANCE_MEETING}/${meetingId}/participants`, data, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getParticipants = (
  meetingId: string,
  all?: boolean,
  page?: number,
  pageSize?: number,
  type?: string,
  sortBy?: string
) => {
  return axios.get(
    `${COMPLIANCE_MEETING}/${meetingId}/participants?${page ? `&page=${page}` : ''}${
      pageSize ? `&pageSize=${pageSize}` : ''
    }${type ? `&type=${type}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}${all ? `&all=${all}` : ''}`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getMeetings = (meetingId: string) => {
  return axios.get(`${COMPLIANCE_MEETING}/${meetingId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateMeetings = (data: any, meetingId: string) => {
  return axios.post(`${COMPLIANCE_MEETING}/${meetingId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteParticipants = (participantId: string) => {
  return axios.delete(`${COMPLIANCE_MEETING}/participants/${participantId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteMeetings = (meetingId: string) => {
  return axios.delete(`${COMPLIANCE_MEETING}/${meetingId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getMeetingLists = (
  meetingType: string,
  attendance?: string,
  date?: string,
  page?: number,
  pageSize?: number,
  type?: string,
  sortBy?: string
) => {
  return axios.get(
    `${COMPLIANCE_MEETING}/all?meetingCategory=${meetingType}${page ? `&page=${page}` : ''}${
      pageSize ? `&pageSize=${pageSize}` : ''
    }${type ? `&type=${type}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}${
      attendance ? `&attendance=${attendance}` : ''
    }${date ? `&date=${date}` : ''}`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createMeetingSummary = (data: any, meetingId: string) => {
  return axios.post(`${COMPLIANCE_MEETING}/${meetingId}/summary`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getMeetingSummary = (meetingId: string) => {
  return axios.get(`${COMPLIANCE_MEETING}/${meetingId}/summary`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateMeetingSummary = (data: any, meetingId: string, summaryId: string) => {
  return axios.post(`${COMPLIANCE_MEETING}/${meetingId}/summary/${summaryId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateMeetingParticipant = (data: any, meetingId: string, participantId: string) => {
  return axios.post(`${COMPLIANCE_MEETING}/${meetingId}/participants/${participantId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const downloadDocument = (name: string, companyId: number) => {
  const key = encodeURIComponent(name)
  return axios.get(`${API_URL}/file/signed/${key}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getIndividuals = (
  companyId: any,
  all: boolean,
  page?: number,
  pageSize?: number,
  type?: string,
  sortBy?: string
) => {
  return axios.get(
    `${API_URL}/stakeholders/individuals?${`all=${all}`}${page ? `&page=${page}` : ''}${
      pageSize ? `&pageSize=${pageSize}` : ''
    }${type ? `&type=${type}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const aiGenerateBr = (data: any, companyId: any) => {
  return axios.post(`${API_URL}/compliance/meetings/ai-board-resolution`, data, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const aiGenerateMoM = (data: any, companyId: any) => {
  return axios.post(`${API_URL}/compliance/meetings/ai-minutes-of-meeting`, data, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const aiGenerateTranscript = (data: any, companyId: any) => {
  return axios.post(`${API_URL}/compliance/meetings/ai-transcript`, data, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getMeetingStats = (companyId: any) => {
  return axios.get(`${COMPLIANCE_MEETING}/stats`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createDuplicateMeeting = (meetingId: string, companyId: any) => {
  return axios.post(`${COMPLIANCE_MEETING}/${meetingId}/duplicate`, '', {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const acceptInvite = (meetingId: string, participantId: string, status: string) => {
  return axios.post(
    `${COMPLIANCE_MEETING}/accept-invite?meetingId=${meetingId}&participantId=${participantId}&status=${status}`,
    '',
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getComplianceExportCsv = (category?: string, email?: string) => {
  return axios.get(
    `${COMPLIANCE_MEETING}/get-export${category ? `?meetingCategory=${category}` : ''}${
      email ? `?meetingEmail=${email}` : ''
    }`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const reorderAgenda = (meetingId: string, agendaId: string, position: number) => {
  return axios.post(
    `${COMPLIANCE_MEETING}/${meetingId}/agenda/${agendaId}/reorder/${position}`,
    null,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}
